import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#f7f7f7',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#4f4f4f',
  800: '#434343',
  900: '#2b2b2b',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#45A5E6',
  main: '#0362A1',
  dark: '#0A2F47',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  main: '#0c3b59',
  light: '#11527c',
  dark: '#082334',
  contrastText: '#FFFFFF',
};

const info: PaletteColorOptions = {
  main: '#6E8FA3',
  dark: '#396887',
  light: '#9ab7cd',
  contrastText: '#FFFFFF',
};

const success: PaletteColorOptions = {
  main: '#8BAD75',
  dark: '#648f54',
  light: '#b7df9c',
  contrastText: '#FFFFFF',
};

const warning: PaletteColorOptions = {
  light: '#D7D9B1',
  main: '#D9A356',
  dark: '#a1773e',
  contrastText: '#000000',
};

const error: PaletteColorOptions = {
  light: '#fca1a1',
  main: '#D95F5D',
  dark: '#a64343',
  contrastText: '#FFFFFF',
};

const lightPalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#2b2b2b',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#fff', default: '#fff' },
};

export default lightPalette;
